import type { ProjectPostGetCommand, ProjectPostGetResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class GetProjectPostUseCase {
  constructor(private projectRepository: ProjectRepository) {}

  async execute(command: ProjectPostGetCommand): Promise<ProjectPostGetResponse> {
    return this.projectRepository.getProjectPost(command);
  }
}
